export function resolveActionUrl(actionUrl: string): string {
  if (!/^https?:\/\//i.test(actionUrl)) {
    return actionUrl;
  }

  try {
    const url = new URL(actionUrl);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return actionUrl;
  }
}
